<template>
  <v-navigation-drawer
    class="app-colors-background mobile-menu"
    width="100%"
    app
    :stateless="false"
    :value="propValue"
    v-on:input="$emit('input', $event)"
  >
  <div  style="min-height: 80%">
    <link-list @close="close" :items="headerItems" />
  </div>
    <locale-changer-toolbar class="localeChanger "></locale-changer-toolbar>
  </v-navigation-drawer>

</template>
<script>
import LinkList from '../_shared/LinkList.vue'
import localeChangerToolbar from '../app/localeChangerToolbar.vue'

export default {
  components: { LinkList, localeChangerToolbar },
  name: 'MobileMenu',
  props: {
    value: {
      required: true,
      type: Boolean
    }
  },
  data: () => ({
    headerItems: []
  }),
  async created() {
    await this.loadHeaderItems()
  },
  computed: {
    propValue: function () {
      return this.value
    }
  },
  methods: {
    async loadHeaderItems() {
      await this.$store.dispatch('loadHeaderSettings')
      var headers = this.$store.getters.headerItems
      headers.forEach(element => {
        this.headerItems.push(element)
      })
    },
    close() {
      this.value = false
    }
  }
}
</script>
<style lang="scss" scoped>
.mobile-menu {
  margin-top: 6rem;
}

.localeChanger {
  margin-left: auto;
  margin-right: auto;
}
</style>
